import { render } from "./discountReadCardModel.vue?vue&type=template&id=2351d755"
import script from "./discountReadCardModel.vue?vue&type=script&lang=js"
export * from "./discountReadCardModel.vue?vue&type=script&lang=js"

import "./discountReadCardModel.vue?vue&type=style&index=0&id=2351d755&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__